import React, { useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import './Menu.scss'
import { motion, AnimatePresence } from 'framer-motion'
const Menu = () => {
    const location = useLocation()
    const [openShop, setOpenShop] = useState(false)
    const [openSurMesure, setOpenSurMesure] = useState(false)
    const navigate = useNavigate()

    const toggleShop = (e) => {
        e.preventDefault()
        setOpenShop((v) => !v)
    }

    const toggleSurMesure = () => {
        setOpenSurMesure((v) => !v)
    }

    return (
        <div className='menu'>
            <Link to="/" onClick={(e) => { if (location.pathname === '/') { e.preventDefault(); window.location.reload(); } }}><p className='buttonMarguerite'>Marguerite Soulier</p></Link>

            <Link to="/about" onClick={(e) => {
                if (openShop) {
                    e.preventDefault()
                    setOpenShop(false)
                    setOpenSurMesure(false)
                    setTimeout(() => navigate('/about'), 360)
                } else if (openSurMesure) {
                    e.preventDefault()
                    setOpenSurMesure(false)
                    setTimeout(() => navigate('/about'), 360)
                }
            }}><p className='buttonAbout'>à propos</p></Link>

            <div className={`shopWrapper${openShop ? ' open' : ''}`}>
                <a href="#" className='buttonShop' onClick={toggleShop}>shop</a>
                <AnimatePresence initial={false}>
                    {openShop && (
                        <motion.div
                            className='submenu'
                            initial={{ height: 0, opacity: 0, y: -8 }}
                            animate={{ height: 'auto', opacity: 1, y: 0 }}
                            exit={{ height: 0, opacity: 0, y: -8 }}
                            transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
                        >
                            <Link to="/petit" onClick={() => { setOpenShop(false); setOpenSurMesure(false); }}><p>petit</p></Link>
                            <Link to="/grand" onClick={() => { setOpenShop(false); setOpenSurMesure(false); }}><p>grand</p></Link>
                            <Link to="/tres-grand" onClick={() => { setOpenShop(false); setOpenSurMesure(false); }}><p>tres-grand</p></Link>
                            <p className='clickable' onClick={toggleSurMesure}>sur mesure</p>
                            <AnimatePresence initial={false}>
                                {openSurMesure && (
                                    <motion.div
                                        className='subsubmenu'
                                        initial={{ height: 0, opacity: 0, y: -6 }}
                                        animate={{ height: 'auto', opacity: 1, y: 0 }}
                                        exit={{ height: 0, opacity: 0, y: -6 }}
                                        transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
                                    >
                                        <p>envoyez votre projet</p>
                                        <p><a href="mailto:soulier.marguerite@gmail.com">soulier.marguerite@gmail.com</a></p>
                                    </motion.div>
                                )}
                            </AnimatePresence>
                        </motion.div>
                    )}
                </AnimatePresence>
            </div>

            <AnimatePresence initial={false}>
                {openSurMesure && (
                    <motion.div
                        className='subsubmenu-overlay'
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        transition={{ duration: 0.25 }}
                    >
                        <div className='overlay-bg' onClick={() => setOpenSurMesure(false)} />
                        <motion.div
                            className='overlay-box'
                            initial={{ scale: 1, opacity: 0, y: 0 }}
                            animate={{ scale: 1, opacity: 1, y: 0 }}
                            exit={{ scale: 1, opacity: 0, y: 0 }}
                            transition={{ duration: 0.25 }}
                        >
                            <p>envoyez votre projet</p>
                            <p><a href="mailto:soulier.marguerite@gmail.com">soulier.marguerite@gmail.com</a></p>
                        </motion.div>
                    </motion.div>
                )}
            </AnimatePresence>
        </div>
    )
}

export default Menu